import 'react-native-get-random-values';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";
import { Capacitor } from "@capacitor/core";

import Login from "./pages/Login";
import Home from "./pages/Home";
import Members from "./pages/Members";
import Events from "./pages/Events";
import Conversations from "./pages/ConversationsList";
import Chat from "./pages/Chat";
import Register from "./pages/Register";
import NewConversation from "./pages/NewConversation";
import Profile from "./pages/Profile";

import Planches from "./pages/Planches";
import Music from "./pages/Music";
import Call from "./pages/Call";
import PdfViewer from "./pages/PdfViewer";
import socket from "./socket";

import usePush from "./hooks/usePush";
import Layout from "./components/Layout";
import API from "./api";
import ResetPasswordScreen from "./pages/ResetPasswordScreen";
import { App as CapApp } from "@capacitor/app";
import { checkForUpdates } from './utils/updateChecker';
import cryptoService from "./services/cryptoService";

const getOrCreateDeviceId = async () => {
  const existing = await Preferences.get({ key: "device_id" });

  if (existing.value) return existing.value;

  const deviceId = crypto.randomUUID();

  await Preferences.set({
    key: "device_id",
    value: deviceId,
  });

  return deviceId;
};

const getDeviceName = () => {
  const ua = navigator.userAgent || "";

  if (/Android/i.test(ua)) return "Android";
  if (/iPhone|iPad/i.test(ua)) return "iPhone / iPad";
  if (/Windows/i.test(ua)) return "PC Windows";
  if (/Mac/i.test(ua)) return "Mac";
  if (/Linux/i.test(ua)) return "Linux";

  return "Appareil inconnu";
};

function App() {
  const { requestWebPushPermission } = usePush();

  const initEncryption = async () => {
  await cryptoService.init();

  const { value: token } = await Preferences.get({ key: "token" });

  if (!token) {
    console.log("Pas de token E2EE");
    return;
  }

  API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  const deviceId = await getOrCreateDeviceId();
  const deviceName = getDeviceName();

  API.defaults.headers.common["x-device-id"] = deviceId;

  const keys = await cryptoService.getKeys();

  console.log("KEYS", keys);

  if (!keys.publicKey || !keys.privateKey) {
    const newKeys = cryptoService.generateKeyPair();

    const keyRes = await API.post("/users/keys", {
      publicKey: newKeys.publicKey,
      deviceId,
      deviceName,
    });

    await cryptoService.saveKeys(
      keyRes.data.keyId,
      newKeys.publicKey,
      newKeys.privateKey
    );

    console.log("Clés E2EE générées");
    return;
  }

  if (!keys.keyId) {
    const keyRes = await API.post("/users/keys", {
      publicKey: keys.publicKey,
      deviceId,
      deviceName,
    });

    await cryptoService.saveKeys(
      keyRes.data.keyId,
      keys.publicKey,
      keys.privateKey
    );

    console.log("Ancienne clé E2EE migrée avec keyId");
    return;
  }

  const syncRes = await API.post("/users/keys", {
  publicKey: keys.publicKey,
  deviceId,
  deviceName,
});

if (
  syncRes.data.keyId &&
  Number(syncRes.data.keyId) !== Number(keys.keyId)
) {
  await cryptoService.saveKeys(
    syncRes.data.keyId,
    keys.publicKey,
    keys.privateKey
  );
}

console.log("Appareil E2EE synchronisé");
};



  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notifications, setNotifications] = useState({});
  const [pendingDevice, setPendingDevice] = useState(null);
  const [showDeviceModal, setShowDeviceModal] = useState(false);
    const [showPushButton, setShowPushButton] = useState(false);

  

  const clearSession = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");

    await Preferences.remove({ key: "token" });
    await Preferences.remove({ key: "refreshToken" });
  };



 // useEffect(() => {
 // checkForUpdates();
//}, []);

  const checkAuth = async () => {
    try {
      const { value: token } = await Preferences.get({ key: "token" });

      if (!token) {
        await clearSession();
        setIsAuthenticated(false);
        setAuthChecked(true);
        return;
      }

      API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      const deviceId = await getOrCreateDeviceId();
API.defaults.headers.common["x-device-id"] = deviceId;

      const meRes = await API.get("/me");

localStorage.setItem("user", JSON.stringify(meRes.data));

setIsAuthenticated(true);
    } catch (err) {
      console.log("Auth invalide:", err);
      await clearSession();
      setIsAuthenticated(false);
    } finally {
      setAuthChecked(true);
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await API.get("/conversations");

      const notif = {};
      res.data.forEach((c) => {
        notif[c.id] = c.unread_count;
      });

      setNotifications(notif);
    } catch (err) {
      console.log("Erreur notifications:", err);
    }
  };

const syncDeviceHistory = async (targetKeyId) => {
  try {
    const keys = await cryptoService.getKeys();

    if (!keys?.privateKey) {
      console.log("Pas de clé privée locale pour synchroniser l'historique");
      return;
    }

    const res = await API.get(`/users/devices/${targetKeyId}/sync-messages`);

    const targetPublicKey = res.data.targetKey?.publicKey;
    const messages = res.data.messages || [];

    if (!targetPublicKey || messages.length === 0) {
      console.log("Aucun message à synchroniser");
      return;
    }

    const syncedMessages = [];

    for (const msg of messages) {
      try {
        const clearText = cryptoService.decryptMessage(
          msg.encrypted_text,
          msg.nonce,
          msg.encryptor_public_key,
          keys.privateKey
        );

        if (!clearText) continue;

        const encrypted = cryptoService.encryptMessage(
          clearText,
          targetPublicKey,
          keys.privateKey
        );

        syncedMessages.push({
          messageId: msg.message_id,
          type: msg.type,
          encrypted: encrypted.encrypted,
          nonce: encrypted.nonce,
        });
      } catch (err) {
        console.log("Message impossible à synchroniser:", msg.message_id, err);
      }
    }

    if (syncedMessages.length === 0) {
      console.log("Aucun message rechiffré");
      return;
    }

    await API.post(`/users/devices/${targetKeyId}/sync-messages`, {
      messages: syncedMessages,
    });

    console.log(`${syncedMessages.length} messages synchronisés`);
  } catch (err) {
    console.log("Erreur synchronisation historique:", err);
  }
};

const approvePendingDevice = async () => {
  if (!pendingDevice) return;

  try {
    const keyId = pendingDevice.keyId;

    await API.post(`/users/devices/${keyId}/approve`);

    await syncDeviceHistory(keyId);

    setShowDeviceModal(false);
    setPendingDevice(null);

    alert("Appareil approuvé et historique synchronisé");
  } catch (err) {
    alert(err?.response?.data?.message || "Impossible d'approuver l'appareil");
  }
};

const rejectPendingDevice = async () => {
  if (!pendingDevice) return;

  try {
    await API.post(`/users/devices/${pendingDevice.keyId}/revoke`);
    setShowDeviceModal(false);
    setPendingDevice(null);
  } catch (err) {
    alert(err?.response?.data?.message || "Impossible de refuser l'appareil");
  }
};

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      if (
        "Notification" in window &&
        Notification.permission === "default"
      ) {
        setShowPushButton(true);
      }
    }
  }, []);

  useEffect(() => {
  (async () => {
    await cryptoService.init();
    console.log("✅ libsodium initialisé");
  })();
}, []);

useEffect(() => {
  if (!isAuthenticated) return;

  initEncryption();
}, [isAuthenticated]);

  useEffect(() => {
  if (!isAuthenticated) return;

  if (!socket.connected) {
    socket.connect();
    console.log("SOCKET CONNECT");
  }
  const user = JSON.parse(localStorage.getItem("user") || "{}");

if (user?.id) {
  socket.emit("register", user.id);
  console.log("SOCKET REGISTER GLOBAL", user.id);
}

  fetchNotifications();

  socket.on("notification", () => {
    fetchNotifications();
  });

  socket.on("device:pending", async (device) => {
  const { value: myDeviceId } = await Preferences.get({
    key: "device_id",
  });

  if (device.deviceId === myDeviceId) {
    return;
  }

  setPendingDevice(device);
  setShowDeviceModal(true);
});

socket.on("device:approved", () => {
  setShowDeviceModal(false);
  setPendingDevice(null);
});

socket.on("device:revoked", () => {
  setShowDeviceModal(false);
  setPendingDevice(null);
});

  return () => {
    socket.off("notification");
    socket.off("device:pending");
    socket.off("device:approved");
    socket.off("device:revoked");
    socket.disconnect();
    console.log("SOCKET DISCONNECT");
  };
}, [isAuthenticated]);

  useEffect(() => {
  CapApp.addListener("appUrlOpen", (event) => {
    console.log("Deep link reçu :", event.url);

    const slug = event.url.replace(
      "libertesolidaire://reset-password/open",
      "/reset-password"
    );

    if (slug) {
      window.location.replace(slug);
    }
  });
}, []);

  if (!authChecked) {
    return null;
  }

  return (
    <Router>

    {showDeviceModal && pendingDevice && (
  <div style={deviceModalStyles.overlay}>
    <div style={deviceModalStyles.box}>
      <div style={deviceModalStyles.icon}>🔐</div>

      <h3 style={deviceModalStyles.title}>Nouvel appareil détecté</h3>

      <p style={deviceModalStyles.text}>
        {pendingDevice.deviceName || "Nouvel appareil"} demande l'accès à votre compte.
      </p>

      <div style={deviceModalStyles.actions}>
        <button style={deviceModalStyles.cancel} onClick={rejectPendingDevice}>
          Refuser
        </button>

        <button style={deviceModalStyles.confirm} onClick={approvePendingDevice}>
          Approuver
        </button>
      </div>
    </div>
  </div>
)}

{showPushButton && isAuthenticated && (
  <div
    style={{
      position: "fixed",
      bottom: 20,
      left: 20,
      right: 20,
      zIndex: 2147483647,
      background: "rgba(255,255,255,0.97)",
      borderRadius: 18,
      padding: 18,
      boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
      textAlign: "center",
    }}
  >
    <div style={{ fontSize: 28, marginBottom: 8 }}>
      🔔
    </div>

    <strong
      style={{
        display: "block",
        color: "#3B3450",
        fontSize: 17,
        marginBottom: 6,
      }}
    >
      Activer les notifications
    </strong>

    <p
      style={{
        color: "#6B6780",
        fontSize: 14,
        margin: "0 0 14px",
      }}
    >
      Recevez les nouveaux messages et les notifications de la loge.
    </p>

   <button
    onClick={async () => {
  const result = await requestWebPushPermission();

  if (
    result === "granted" ||
    Notification.permission === "granted"
  ) {
    setShowPushButton(false);
  }
}}
      style={{
        width: "100%",
        padding: 13,
        borderRadius: 12,
        border: "none",
        background:
          "linear-gradient(135deg, #8FAE5D, #9AB86A)",
        color: "#fff",
        fontWeight: "800",
        fontSize: 15,
        cursor: "pointer",
      }}
    >
      Activer les notifications
    </button>
  </div>
)}

      <Routes>

        <Route
              path="/reset-password"
              element={<ResetPasswordScreen />}
            /> 
            
        {!isAuthenticated && (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}

        {isAuthenticated && (
          <>
            <Route path="/" element={<Navigate to="/home" replace />} />

            <Route
              path="/home"
              element={
                <Layout notifications={notifications}>
                  <Home />
                </Layout>
              }
            />

            <Route
              path="/members"
              element={
                <Layout notifications={notifications}>
                  <Members />
                </Layout>
              }
            />

            <Route
              path="/events"
              element={
                <Layout notifications={notifications}>
                  <Events />
                </Layout>
              }
            />

            <Route
              path="/messages"
              element={
                <Layout notifications={notifications}>
                  <Conversations />
                </Layout>
              }
            />

            <Route path="/pdf-viewer" element={<PdfViewer />} />


            <Route
              path="/new-chat"
              element={
                <Layout notifications={notifications}>
                  <NewConversation />
                </Layout>
              }
            />

            <Route
              path="/new-conversation"
              element={
                <Layout notifications={notifications}>
                  <NewConversation />
                </Layout>
              }
            />

            <Route
              path="/chat/:conversationId"
              element={
                <Layout notifications={notifications}>
                  <Chat />
                </Layout>
              }
            />

            <Route
              path="/register"
              element={
                <Layout notifications={notifications}>
                  <Register />
                </Layout>
              }
            />

            <Route
              path="/profile"
              element={
                <Layout notifications={notifications}>
                  <Profile />
                </Layout>
              }
            />

            <Route
              path="/planches"
              element={
                <Layout notifications={notifications}>
                  <Planches />
                </Layout>
              }
            />

            <Route
              path="/music"
              element={
                <Layout notifications={notifications}>
                  <Music />
                </Layout>
              }
            />

            

            <Route path="/call/:userId" element={<Call />} />

            <Route path="*" element={<Navigate to="/home" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
const deviceModalStyles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.75)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    zIndex: 9999,
  },

  box: {
    width: "100%",
    maxWidth: 340,
    background: "rgba(255,255,255,0.95)",
    border: "1px solid rgba(143,174,93,0.25)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 20px 70px rgba(0,0,0,0.9)",
    textAlign: "center",
  },

  icon: {
    fontSize: 34,
    marginBottom: 10,
  },

  title: {
    color: "#3B3450",
    fontSize: 21,
    margin: "0 0 8px",
  },

  text: {
    color: "#6B6780",
    fontSize: 14,
    lineHeight: 1.5,
    marginBottom: 20,
  },

  actions: {
    display: "flex",
    gap: 10,
  },

  cancel: {
    flex: 1,
    padding: 13,
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.85)",
    color: "#3B3450",
    fontWeight: "700",
    cursor: "pointer",
  },

  confirm: {
    flex: 1,
    padding: 13,
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#fff",
    fontWeight: "800",
    cursor: "pointer",
  },
};